var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmileyHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,0A16,16,0,1,0,32,16,16.018,16.018,0,0,0,16,0Zm0,29.34A13.34,13.34,0,1,1,29.34,16,13.356,13.356,0,0,1,16,29.34ZM13.326,15.377h-2.66V8.063h2.66Zm7.979,0h-2.66V8.063H21.3Zm4.44,4.408A10.393,10.393,0,0,1,16,26.1a10.393,10.393,0,0,1-9.745-6.314l2.46-1.01A7.845,7.845,0,0,0,16,23.439a7.845,7.845,0,0,0,7.284-4.664Z",
    fill: "#0071B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyHappy);
export default __webpack_public_path__ + "static/media/icon-smiley-happy.d35ff38bc3a407c36fa5e9e80b73766d.svg";
export { ForwardRef as ReactComponent };